import FormField from './form_field';
import { SIZE, ALIGN } from 'form/constants/label_component_enuns.js';

export default class LabelFormField extends FormField {
	_align;
	_color;
	_backgroundColor;
	_size;

	constructor(fieldProps = {}) {
		super(fieldProps);
	}

	get align() {
		return this._align;
	}

	set align(value) {
		if (ALIGN[value]) {
			this._align = value;
		} else {
			throw new Error("Property 'align' have just these properties: left, center and right");
		}
	}


	get color() {
		return this._color;
	}

	set color(value) {
		this._color = value;
	}


	get backgroundColor() {
		return this._backgroundColor;
	}

	set backgroundColor(value) {
		this._backgroundColor = value;
	}


	get size() {
		return this._size;
	}

	set size(value) {
		if (SIZE[value]) {
			this._size = value;
		} else {
			throw new Error("Property 'size' have just these properties: small, medium and large");
		}
	}
}
